module.exports = __webpack_public_path__ + "assets/arrow.06d4275b.svg";